// VideoTestimonials.jsx
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { fetchPatientVideos } from "../Adapter/HomePageAdapter";
import playIcon from "../assets/images/speci-detail/vdoplybtn.png";
import fallbackImage from "../assets/images/pat1.png";

const VideoTestimonials = () => {
    const [videoTestimonials, setVideoTestimonials] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const videoResponse = await fetchPatientVideos();

                if (videoResponse?.data) {
                    const sanitizedVideos = videoResponse.data.map((video) => {
                        const videoIdMatch = video.video_link?.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|.+\?v=))([^&]+)/);
                        const videoId = videoIdMatch ? videoIdMatch[1] : null;

                        return {
                            ...video,
                            video_link: video.video_link?.replace("watch?v=", "embed/"),
                            thumbnail: videoId
                                ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` // High-quality thumbnail
                                : fallbackImage
                        };
                    });

                    setVideoTestimonials(sanitizedVideos);
                }
            } catch (err) {
                setError("Failed to load patient videos.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <>
            {/* <div className="video-stories">
                <Swiper
                    className="opdcarousel thisweek-slider videoslider"
                    modules={[Autoplay, Navigation, Pagination, EffectCoverflow]}
                    loop={true}
                    speed={1500}
                    effect="coverflow"
                    grabCursor={false}
                    centeredSlides={true}
                    watchSlidesProgress={true}
                    watchSlidesVisibility={true}
                    slidesPerView={2.5}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 150,
                        depth: 250,
                        modifier: 1,
                        slideShadows: false,
                    }}
                    pagination={{ clickable: true, el: ".swiper-pagination1" }}
                    navigation={{
                        nextEl: ".swiper-cust1-next",
                        prevEl: ".swiper-cust1-prev",
                    }}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        1024: { slidesPerView: 2.5 },
                    }}
                >
                    {videoTestimonials.map((video, index) => (
                        <SwiperSlide key={index}>
                            <div className="thisweek-slider-inner" style={{ borderRadius: "20px", overflow: "hidden" }}>
                                <div className="overlaywhite"></div>
                                <img
                                    src={video.thumbnail}
                                    alt={video.name || "Patient Video"}
                                />
                                <div className="patient-videoPlaybtn">
                                    <button onClick={() => setSelectedVideo(video.video_link)}>
                                        <img src={playIcon} alt="Play Button" />
                                    </button>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="videostory-cta" style={{ cursor: "pointer" }}>
                    <span className="swiper-cust1-prev"> &lt; </span>
                    <div className="vdostory-naviga">
                        <span className="swiper-pagination1"></span>
                    </div>
                    <span className="swiper-cust1-next"> &gt; </span>
                </div>

                {selectedVideo && (
                    <div className="video-popup" onClick={() => setSelectedVideo(null)}>
                        <div className="video-popup-content">
                            <iframe
                                width="800"
                                height="450"
                                src={selectedVideo}
                                title="Patient Story Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                            <button className="close-btn" onClick={() => setSelectedVideo(null)}>✕</button>
                        </div>
                    </div>
                )}
            </div> */}

            <div className="video-stories">
                <Swiper
                    className="thisweek-slider videoslider"
                    modules={[Autoplay, Navigation, Pagination, EffectCoverflow]}
                    loop={true}
                    speed={1500}
                    effect="coverflow"
                    grabCursor={false}
                    centeredSlides={true}
                    watchSlidesProgress={true}
                    watchSlidesVisibility={true}
                    slidesPerView={1.5}
                    spaceBetween={100}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 0,
                        depth: 200,
                        modifier: 1,
                        slideShadows: false,
                    }}
                    pagination={{ clickable: true, el: ".swiper-vdo-pagination" }}
                    navigation={{
                        enabled: true,
                        nextEl: ".swiper-cust1-next",
                        prevEl: ".swiper-cust1-prev",
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1.1,
                            spaceBetween: 40
                            // coverflowEffect: {
                            //     rotate: 0,
                            //     stretch: 0,
                            //     depth: 100,
                            //     modifier: 1,
                            //     slideShadows: false,
                            // },
                        },
                        640: {
                            slidesPerView: 1.5,
                            spaceBetween: 40
                        },
                        1024: {
                            slidesPerView: 1.5,
                        },
                    }}

                >
                    {videoTestimonials.map((video, index) => (
                        <SwiperSlide key={index}>
                            <div className="newvideo-slider-inner">
                                <div className="overlayblack"></div>
                                <img
                                    src={video.thumbnail}
                                    alt={video.name || "Patient Video"}
                                />
                                <div className="patient-videoPlaybtn">
                                    <button onClick={() => setSelectedVideo(video.video_link)}>
                                        <img src={playIcon} alt="Play Button" />
                                    </button>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {/* <div className="videoslider-navigation">
                    <span className="swiper-cust1-prev">&lt;</span>
                    <span className="swiper-cust1-next"> &gt;</span>
                </div> */}
                <div className="vdostory-pagination">
                    <span className="swiper-vdo-pagination"></span>
                </div>
            </div>

            {/* Video Popup Modal */}
            {selectedVideo && (
                <div className="video-popup" onClick={() => setSelectedVideo(null)}>
                    <div className="video-popup-content">
                        <iframe width="800" height="450" src={selectedVideo} title="Patient Story Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        <button className="close-btn" onClick={() => setSelectedVideo(null)}>✕</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default VideoTestimonials;